

export default function ExerciserSingleValueAnswerInput({value, placeholder, onInputClicked}) {
    // Used in Exerciser that expects a typed single value as answer

    // BUILD
    return (
        <div className={`mt-[24px] flex justify-center items-center cursor-auto select-none w-[204px] min-w-[204px] h-[56px] bg-transparent text-center border-[2px] border-primary rounded-[8px] py-[4px] ${renderTextStyle()}`}
             onClick={onInputClicked} >
            {value || (placeholder ?? "")}
        </div>
    )

    // METHODS
    // ---- UI : Render text style
    function renderTextStyle() {
        return value === ""
            ? "text-greyLight5 font-normal text-[22px]"
            : "text-white font-medium text-[26px]"
    }
}